import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { WithApp } from 'contexts/appContext';
import { wsCreate } from 'services/WService.js';

const fileTypes = ['JPG', 'PNG'];

/**
 * Categoría del mueble: qué ES cada mueble físico.
 *
 * No confundir con "Rango venta de mueble", que son los tramos de
 * venta del cliente. Varios muebles comparten una categoría.
 */
export default WithApp(function ModalFurnitureCategory(props) {
  const category = props.model;
  const esNueva = !category?.id;

  const [fotoUrl, setFotoUrl] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [version, setVersion] = useState(1);

  useEffect(() => {
    setFotoUrl(category?.file_url || null);
  }, [category]);

  //la foto va aparte del guardado: necesita que la categoría ya exista
  async function subirFoto(file) {
    let fd = new FormData();
    fd.append('photo', file);

    setSubiendo(true);
    let res = await wsCreate(`base/furniture-category/${category.id}/photo`, fd);
    setSubiendo(false);

    if (res.success) {
      //el ?v= fuerza al navegador a recargarla: la URL no cambia al reemplazarla
      setFotoUrl(`${res.data.file_url}?v=${version}`);
      setVersion((v) => v + 1);
      props.showNotify(res.message);
      props.reload();
    } else {
      props.showNotify(res.message, 'error');
    }
  }

  return (
    <Modal
      title="Categoría de mueble"
      model={category}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/furniture-category"
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={category?.code || ''}
        inputProps={{ maxLength: 20 }}
        helperText="No se puede repetir"
        required
      />

      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={category?.description || ''}
        helperText="Por ejemplo Chico, Grande o Abierto para autoservicio"
        required
      />

      {/* La foto necesita que la categoría exista para colgársela */}
      {esNueva ? (
        <p style={{ color: '#9a9a9a', marginTop: 16 }}>
          La foto se agrega volviendo a abrir la categoría, una vez guardada.
        </p>
      ) : (
        <div style={{ marginTop: 16 }}>
          <p style={{ marginBottom: 6 }}>Foto referencial</p>

          {fotoUrl && !subiendo && (
            <div style={{ maxWidth: '260px', marginBottom: '10px' }}>
              <img
                src={fotoUrl}
                alt="Categoría de mueble"
                style={{ width: '100%', borderRadius: 6 }}
              />
            </div>
          )}

          {subiendo && (
            <div style={{ width: '60px', height: '60px', marginBottom: '10px' }}>
              <div className="lds-dual-ring"></div>
            </div>
          )}

          <FileUploader
            handleChange={subirFoto}
            types={fileTypes}
            disabled={subiendo}
            label="Has click o arrastra una imagen aquí"
            hoverTitle="Suelta la imagen aquí"
            maxSize={2}
          />
        </div>
      )}
    </Modal>
  );
});
